import axios from "axios";
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

const API_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = secureStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const scheduleUserUpdate = async (userId, payload) => {
  try {
    const response = await api.post(`/user/${userId}/schedule-update`, payload);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error.message ||
      "No se pudo programar la actualización";
    throw new Error(message);
  }
};

export const getScheduledJobs = async ({ page = 1, limit = 10, userId } = {}) => {
  try {
    const response = await api.get(`/admin/scheduled-jobs`, {
      params: { page, limit, userId },
    });
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error.message ||
      "No se pudieron obtener los trabajos programados";
    throw new Error(message);
  }
};

export const swapUserSchedules = async ({ firstUserId, secondUserId, startAt, endAt, reason }) => {
  try {
    const response = await api.post(`/user/swap-schedule`, {
      firstUserId,
      secondUserId,
      startAt,
      endAt,
      reason,
    });
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error.message ||
      "No se pudo intercambiar los horarios";
    throw new Error(message);
  }
};

export const logSwapEvent = async ({ usuarioA, usuarioB, motivo, fechainicio, fechafin, id_usuario }) => {
  try {
    const response = await api.post(`/intercambio`, {
      usuarioA,
      usuarioB,
      motivo,
      fechainicio,
      fechafin,
      id_usuario,
    });
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error.message ||
      "No se pudo registrar el intercambio";
    throw new Error(message);
  }
};

export const getSwapHistory = async () => {
 try {
    const response = await api.get('intercambio'); 
    return response.data;
  } catch (error) {
    console.error('Error al obtener productos tejidos:', error);
    throw error;
  }
};
